import React, { useState, useEffect } from 'react'
import {
  Folder,
  Check,
  FileText,
  Monitor,
  Tablet as TabletIcon,
  Smartphone,
  RefreshCw,
  X,
} from 'lucide-react'
import { useUITheme } from '../context/UIThemeContext'

// ─── TYPES & INTERFACES ──────────────────────────────────────────
export interface PaperLoanRow {
  id: string
  name: string
  dateGrant: string
  principal: number
  data1530: string | number
  ene1530: string | number
  peb1528: string | number
  pcb1528: string | number
  abr1528: string | number
  maj1528: string | number
  jun1528: string | number
  abr2_1528: string | number
  oct1528: string | number
  dec1530: string | number
  balance: number
  category: 'REGULAR' | 'JOB_ORDER' | 'BARANGAY' | 'SENIOR' | 'HEALTH_CENTER' | 'BHW' | 'BNS' | 'KAGAWAD'
  statusRemark: 'SULDO' | 'SHED' | 'PAID'
}

// ─── INITIAL PIXEL-CLONED SAMPLE DATA ────────────────────────────
export const INITIAL_PAPER_LOANS: PaperLoanRow[] = [
  {
    id: '1',
    name: 'REYNAN TOMOLING',
    dateGrant: '09 25 2024',
    principal: 12000,
    data1530: 350,
    ene1530: 360,
    peb1528: '5/60',
    pcb1528: '5/60',
    abr1528: '',
    maj1528: '',
    jun1528: '',
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 14499.0,
    category: 'REGULAR',
    statusRemark: 'SULDO',
  },
  {
    id: '2',
    name: 'ALBERT ADLAWON',
    dateGrant: '09 25 2024',
    principal: 9000,
    data1530: 165,
    ene1530: 150,
    peb1528: 90,
    pcb1528: 90,
    abr1528: '',
    maj1528: '',
    jun1528: '',
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 10160.0,
    category: 'REGULAR',
    statusRemark: 'SULDO',
  },
  {
    id: '3',
    name: 'DISMAR ADLAWON',
    dateGrant: '09 25 2024',
    principal: 3000,
    data1530: 165,
    ene1530: 150,
    peb1528: 60,
    pcb1528: 20,
    abr1528: 260,
    maj1528: '',
    jun1528: '',
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 15702.0,
    category: 'JOB_ORDER',
    statusRemark: 'SULDO',
  },
  {
    id: '4',
    name: 'RENNIE MARIE ADLAWON',
    dateGrant: '09 25 2024',
    principal: 3100,
    data1530: 165,
    ene1530: 90,
    peb1528: 90,
    pcb1528: 90,
    abr1528: 110,
    maj1528: '',
    jun1528: '',
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 12000.0,
    category: 'HEALTH_CENTER',
    statusRemark: 'SULDO',
  },
  {
    id: '5',
    name: 'STEPHANIE ADOLES',
    dateGrant: '09 25 2024',
    principal: 5000,
    data1530: 150,
    ene1530: 150,
    peb1528: 150,
    pcb1528: 190,
    abr1528: 140,
    maj1528: 160,
    jun1528: 125,
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 12000.0,
    category: 'HEALTH_CENTER',
    statusRemark: 'SULDO',
  },
  {
    id: '6',
    name: 'MARCIAL AUS',
    dateGrant: '09 25 2024',
    principal: 5000,
    data1530: 150,
    ene1530: 150,
    peb1528: 150,
    pcb1528: 90,
    abr1528: 140,
    maj1528: 140,
    jun1528: 130,
    abr2_1528: 120,
    oct1528: '',
    dec1530: '',
    balance: 9424.6,
    category: 'REGULAR',
    statusRemark: 'SULDO',
  },
  {
    id: '7',
    name: 'Mga Barangay Health Center',
    dateGrant: '09 25 2024',
    principal: 5000,
    data1530: 150,
    ene1530: 150,
    peb1528: 150,
    pcb1528: 90,
    abr1528: 140,
    maj1528: 125,
    jun1528: '',
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 3133.6,
    category: 'HEALTH_CENTER',
    statusRemark: 'SULDO',
  },
  {
    id: '8',
    name: 'Mga BNS',
    dateGrant: '09 25 2024',
    principal: 5000,
    data1530: 150,
    ene1530: 150,
    peb1528: 150,
    pcb1528: 150,
    abr1528: 145,
    maj1528: 195,
    jun1528: 95,
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 2374.4,
    category: 'BNS',
    statusRemark: 'SULDO',
  },
  {
    id: '9',
    name: 'Mga BHW',
    dateGrant: '09 30 2024',
    principal: 5000,
    data1530: 650,
    ene1530: 100,
    peb1528: '',
    pcb1528: '',
    abr1528: '',
    maj1528: '',
    jun1528: '',
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 1420.6,
    category: 'BHW',
    statusRemark: 'SULDO',
  },
  {
    id: '10',
    name: 'JOSE LOUIE AYOC',
    dateGrant: '15 15 2024',
    principal: 16000,
    data1530: '',
    ene1530: 195,
    peb1528: 195,
    pcb1528: 145,
    abr1528: 195,
    maj1528: 195,
    jun1528: 95,
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 1420.2,
    category: 'JOB_ORDER',
    statusRemark: 'SHED',
  },
  {
    id: '11',
    name: 'ALEK BALMES',
    dateGrant: '2 19 2024',
    principal: 10000,
    data1530: '',
    ene1530: 150,
    peb1528: 180,
    pcb1528: 300,
    abr1528: 160,
    maj1528: 120,
    jun1528: 150,
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 1120.6,
    category: 'JOB_ORDER',
    statusRemark: 'SHED',
  },
  {
    id: '12',
    name: 'JOSIE RALICUS',
    dateGrant: '27 24 2024',
    principal: 8000,
    data1530: '',
    ene1530: 270,
    peb1528: 250,
    pcb1528: 250,
    abr1528: 500,
    maj1528: 200,
    jun1528: 150,
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 2169.6,
    category: 'SENIOR',
    statusRemark: 'SULDO',
  },
  {
    id: '13',
    name: 'ANTHONY BONOTE',
    dateGrant: '39 26 2024',
    principal: 3000,
    data1530: '',
    ene1530: 250,
    peb1528: 250,
    pcb1528: 250,
    abr1528: 350,
    maj1528: 300,
    jun1528: 700,
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 2540.6,
    category: 'SENIOR',
    statusRemark: 'SULDO',
  },
  {
    id: '14',
    name: 'Mga Barangay Kagawad',
    dateGrant: '19 36 2024',
    principal: 14000,
    data1530: '',
    ene1530: '',
    peb1528: 325,
    pcb1528: 350,
    abr1528: '',
    maj1528: '',
    jun1528: '',
    abr2_1528: '',
    oct1528: '',
    dec1530: '',
    balance: 676.6,
    category: 'KAGAWAD',
    statusRemark: 'SULDO',
  },
]

// ─── REALISTIC HANDWRITTEN SIGNATURE SVG ─────────────────────────
export function CursiveSignatureSVG({ className = 'h-14 w-40' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 320 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20 60 C 35 25, 45 15, 65 30 C 75 40, 50 65, 80 50 C 95 40, 110 30, 130 55 C 145 70, 150 40, 170 35 C 190 30, 200 65, 220 50 C 235 40, 250 25, 280 45 C 295 55, 300 35, 310 40"
        stroke="currentColor"
        className="text-stone-900"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 75 C 90 70, 180 72, 290 68"
        stroke="currentColor"
        className="text-stone-600"
        strokeWidth="1.2"
        strokeDasharray="4 3"
      />
    </svg>
  )
}

// ─── MAIN PAPER LOAN UI COMPONENT ───────────────────────────────
export const PaperLoanUI: React.FC<{ forceView?: 'pc' | 'tablet' | 'phone' }> = ({
  forceView,
}) => {
  const { theme, deviceView, setDeviceView } = useUITheme()

  const [activeView, setActiveView] = useState<'pc' | 'tablet' | 'phone'>(() => {
    if (forceView) return forceView
    if (deviceView && deviceView !== 'auto') return deviceView
    if (typeof window !== 'undefined') {
      const w = window.innerWidth
      if (w < 640) return 'phone'
      if (w < 1024) return 'tablet'
      return 'pc'
    }
    return 'pc'
  })

  // Keep responsive in sync if auto
  useEffect(() => {
    if (forceView) {
      setActiveView(forceView)
      return
    }
    if (deviceView !== 'auto') {
      setActiveView(deviceView)
      return
    }
    const handleResize = () => {
      const w = window.innerWidth
      if (w < 640) setActiveView('phone')
      else if (w < 1024) setActiveView('tablet')
      else setActiveView('pc')
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [deviceView, forceView])

  // Data state
  const [rows, setRows] = useState<PaperLoanRow[]>(INITIAL_PAPER_LOANS)
  const [pcFolderTab, setPcFolderTab] = useState<
    'REGULAR' | 'JOB_ORDER' | 'BARANGAY' | 'SENIOR' | 'SETTINGS'
  >('REGULAR')
  const [tabletTab, setTabletTab] = useState<
    'TANANG' | 'REGULAR' | 'HEALTH_CENTER' | 'SENIOR'
  >('TANANG')

  // Voucher interactive state
  const [voucherAmount, setVoucherAmount] = useState<number>(50000)
  const [voucherRemaining] = useState<number>(37451)
  const [actionMessage, setActionMessage] = useState<string | null>(null)

  const showToast = (msg: string) => {
    setActionMessage(msg)
    setTimeout(() => {
      setActionMessage(null)
    }, 4000)
  }

  // Filter rows by current tabs
  const filteredPcRows = rows.filter((r) => {
    if (pcFolderTab === 'REGULAR') return r.category === 'REGULAR' || r.category === 'HEALTH_CENTER'
    if (pcFolderTab === 'JOB_ORDER') return r.category === 'JOB_ORDER'
    if (pcFolderTab === 'BARANGAY') return r.category === 'BARANGAY' || r.category === 'BHW' || r.category === 'BNS' || r.category === 'KAGAWAD'
    if (pcFolderTab === 'SENIOR') return r.category === 'SENIOR'
    return true
  })

  const filteredTabletRows = rows.filter((r) => {
    if (tabletTab === 'TANANG') return true
    if (tabletTab === 'REGULAR') return r.category === 'REGULAR' || r.category === 'JOB_ORDER'
    if (tabletTab === 'HEALTH_CENTER') return r.category === 'HEALTH_CENTER' || r.category === 'BHW' || r.category === 'BNS'
    if (tabletTab === 'SENIOR') return r.category === 'SENIOR' || r.category === 'KAGAWAD'
    return true
  })

  const totalTabletPaid = filteredTabletRows.reduce((sum, r) => {
    const p =
      typeof r.data1530 === 'number'
        ? r.data1530
        : parseFloat(String(r.data1530 || '0').replace(/[^0-9.]/g, '')) || 1000
    return sum + p * 4.5
  }, 0)

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-200 via-amber-100 to-amber-200 p-4 font-sans text-stone-900 antialiased">
      {/* ─── TOP DEVICE CONTROLS BAR (For testing & switching) ─── */}
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-stone-400/50 bg-amber-100/90 p-3 shadow-md backdrop-blur-sm">
        <div className="flex items-center gap-2">
          <span className="flex items-center gap-1.5 rounded-full bg-stone-900 px-3 py-1 text-xs font-bold uppercase tracking-wider text-amber-100 shadow">
            <FileText className="h-3.5 w-3.5 text-amber-300" />
            Paper Loan UI — Cebu/Bisaya Ledger
          </span>
          {theme === 'paper-loan-ledger' && (
            <span className="rounded bg-green-700 px-2 py-0.5 text-[11px] font-semibold text-white">
              Active in Settings
            </span>
          )}
        </div>

        {/* Viewport Switcher Buttons */}
        <div className="flex items-center gap-1 rounded-lg border border-stone-400/40 bg-stone-200 p-1">
          <button
            type="button"
            onClick={() => setDeviceView('pc')}
            className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-bold transition-all ${
              deviceView === 'pc' || (deviceView === 'auto' && activeView === 'pc')
                ? 'bg-amber-50 text-stone-900 shadow-sm ring-1 ring-stone-500'
                : 'text-stone-700 hover:bg-stone-300'
            }`}
          >
            <Monitor className="h-3.5 w-3.5" />
            PC Desktop
          </button>
          <button
            type="button"
            onClick={() => setDeviceView('tablet')}
            className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-bold transition-all ${
              deviceView === 'tablet' || (deviceView === 'auto' && activeView === 'tablet')
                ? 'bg-amber-50 text-stone-900 shadow-sm ring-1 ring-stone-500'
                : 'text-stone-700 hover:bg-stone-300'
            }`}
          >
            <TabletIcon className="h-3.5 w-3.5" />
            Tablet
          </button>
          <button
            type="button"
            onClick={() => setDeviceView('phone')}
            className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-bold transition-all ${
              deviceView === 'phone' || (deviceView === 'auto' && activeView === 'phone')
                ? 'bg-amber-50 text-stone-900 shadow-sm ring-1 ring-stone-500'
                : 'text-stone-700 hover:bg-stone-300'
            }`}
          >
            <Smartphone className="h-3.5 w-3.5" />
            Mobile Phone
          </button>
          <button
            type="button"
            onClick={() => setDeviceView('auto')}
            className={`flex items-center gap-1 rounded-md px-2.5 py-1.5 text-xs font-medium transition-all ${
              deviceView === 'auto'
                ? 'bg-amber-800 text-white shadow-sm'
                : 'text-stone-700 hover:bg-stone-300'
            }`}
          >
            Auto
          </button>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => {
              setRows([...INITIAL_PAPER_LOANS])
              showToast('Manila paper ledger data refreshed to match attached image!')
            }}
            className="flex items-center gap-1 rounded-lg border border-stone-400/50 bg-amber-200 px-3 py-1.5 text-xs font-bold text-stone-900 hover:bg-amber-300 shadow-sm"
          >
            <RefreshCw className="h-3.5 w-3.5" />
            Reset Ledger
          </button>
        </div>
      </div>

      {/* Action Notification Toast */}
      {actionMessage && (
        <div className="fixed top-6 right-6 z-50 flex items-center gap-2 rounded-xl border-2 border-stone-700 bg-stone-900 px-4 py-3 text-sm font-semibold text-amber-50 shadow-2xl animate-fade-in">
          <Check className="h-5 w-5 text-amber-400" />
          <span>{actionMessage}</span>
          <button onClick={() => setActionMessage(null)} className="ml-3 text-amber-200">
            <X className="h-4 w-4" />
          </button>
        </div>
      )}

      {/* ─── RENDER SELECTED PIXEL-CLONE VIEW ─────────────────── */}
      <div className="flex justify-center">
        {activeView === 'pc' && (
          <PCDesktopLedgerView
            rows={filteredPcRows}
            activeTab={pcFolderTab}
            onSelectTab={setPcFolderTab}
            showToast={showToast}
          />
        )}
        {activeView === 'tablet' && (
          <TabletCollectionSheetView
            rows={filteredTabletRows}
            activeTab={tabletTab}
            onSelectTab={setTabletTab}
            totalPaid={totalTabletPaid}
            showToast={showToast}
          />
        )}
        {activeView === 'phone' && (
          <MobilePhoneVoucherView
            amount={voucherAmount}
            remaining={voucherRemaining}
            setAmount={setVoucherAmount}
            showToast={showToast}
          />
        )}
      </div>
    </div>
  )
}

// ─── 1. PC DESKTOP MANILA FOLDER LEDGER VIEW ─────────────────────
function PCDesktopLedgerView({
  rows,
  activeTab,
  onSelectTab,
  showToast,
}: {
  rows: PaperLoanRow[]
  activeTab: string
  onSelectTab: (tab: any) => void
  showToast: (msg: string) => void
}) {
  const folderTabs = [
    { id: 'REGULAR', label: 'MGA REGULAR HOA EMPLEYADO' },
    { id: 'JOB_ORDER', label: 'MGA JOB ORDER NGA EMPLEYADO' },
    { id: 'BARANGAY', label: 'MGA BARANGAY EMPLEYADO' },
    { id: 'SENIOR', label: 'MGA SENIOR CITIZEN' },
    { id: 'SETTINGS', label: 'MGA SETTINGS' },
  ]

  const subIndexCategories = [
    { label: 'Mga Barangay Health Center', count: 7 },
    { label: 'Mga BNS', count: 4 },
    { label: 'Mga BHW', count: 5 },
    { label: 'Mga Senior Citizen', count: 12 },
    { label: 'Mga Barangay Kagawad', count: 6 },
  ]

  return (
    <div className="w-full max-w-7xl overflow-hidden rounded-2xl border-4 border-stone-800 bg-stone-950 p-3 shadow-2xl">
      {/* Desktop Monitor Top Bar */}
      <div className="mb-2 flex items-center justify-between px-3 py-1 text-xs text-stone-400">
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 rounded-full bg-red-500/80" />
          <div className="h-3 w-3 rounded-full bg-amber-500/80" />
          <div className="h-3 w-3 rounded-full bg-green-500/80" />
          <span className="font-mono font-semibold text-amber-200">
            PANGUNA NGA TALAAN SA UTANG — BARANGAY HEALTH CENTER WORKERS
          </span>
        </div>
        <span className="font-mono text-xs">PHP Currency · Good For ₱50,000.00</span>
      </div>

      {/* Main Folder Container */}
      <div className="relative flex min-h-[660px] rounded-xl bg-amber-200 p-2 shadow-inner">
        {/* Left Vertical Manila Folder Tabs */}
        <div className="flex w-44 shrink-0 flex-col gap-1.5 pr-2">
          {folderTabs.map((t) => {
            const isActive = activeTab === t.id
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => onSelectTab(t.id as any)}
                className={`flex items-center justify-between rounded-l-xl px-3 py-3 text-left font-sans text-[11px] font-extrabold uppercase leading-tight transition-all ${
                  isActive
                    ? 'bg-amber-50 text-stone-900 shadow-lg ring-1 ring-stone-500 -mr-3 z-10 font-black'
                    : 'bg-stone-300 text-stone-700 hover:bg-stone-200'
                }`}
              >
                <span>{t.label}</span>
              </button>
            )
          })}

          {/* Rotated INDEX tab label on the left edge */}
          <div className="mt-8 flex items-center justify-center py-6">
            <span className="rotate-[-90deg] font-mono text-xs font-extrabold tracking-widest text-stone-600 uppercase">
              INDEEX
            </span>
          </div>
        </div>

        {/* Manila Paper Ledger Main Sheet */}
        <div className="relative flex-1 overflow-hidden rounded-xl border-2 border-stone-500 bg-amber-50 p-5 shadow-lg">
          {/* Top Header Block */}
          <div className="mb-4 flex flex-wrap items-start justify-between gap-4 border-b-2 border-stone-400 pb-4">
            <div>
              <h1 className="text-2xl font-black tracking-wide text-stone-900 uppercase">
                PANGUNA NGA TALAAN SA UTANG
              </h1>
              <p className="mt-0.5 text-sm font-bold uppercase tracking-wider text-stone-700">
                BARANGAY HEALTH CENTER WORKERS
              </p>
            </div>

            {/* Top Right "MGA KLIYENTE" Box */}
            <div className="rounded-lg border-2 border-stone-400 bg-amber-100 px-5 py-2 text-right shadow-sm">
              <p className="text-xs font-black uppercase tracking-wider text-stone-800">
                MGA KLIYENTE
              </p>
              <p className="text-xs font-semibold text-stone-600">
                PINAKADAKO NGA KANTIDAD SA HUWAMAN (Good For)
              </p>
              <p className="mt-0.5 font-mono text-2xl font-black text-stone-950">
                ₱50,000.00
              </p>
            </div>
          </div>

          {/* Ledger Table Section */}
          <div className="relative">
            {/* Floating Index Popup Card (Overlaid on left as in the image) */}
            <div className="absolute left-1 top-24 z-20 w-56 rounded-xl border-2 border-stone-500 bg-amber-100/95 p-3 shadow-2xl backdrop-blur-sm">
              <p className="mb-2 border-b border-stone-400/40 pb-1 text-[11px] font-extrabold uppercase tracking-wider text-stone-800">
                Index Categorization
              </p>
              <div className="space-y-1.5">
                {subIndexCategories.map((sub, i) => (
                  <button
                    key={i}
                    type="button"
                    onClick={() =>
                      showToast(`Filtered index category: ${sub.label}`)
                    }
                    className="flex w-full items-center gap-2 rounded-lg px-2.5 py-1.5 text-left text-xs font-bold text-stone-900 hover:bg-amber-200 transition-colors"
                  >
                    <Folder className="h-4 w-4 shrink-0 text-amber-700" />
                    <span className="truncate">{sub.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Main Ledger Table */}
            <div className="overflow-x-auto rounded-lg border-2 border-stone-500 bg-amber-50">
              <table className="w-full border-collapse text-left font-sans text-xs">
                <thead>
                  <tr className="bg-amber-200 font-bold text-stone-900">
                    <th className="border-b border-r border-stone-500 px-3 py-2 text-left">
                      NGALAN
                    </th>
                    <th className="border-b border-r border-stone-500 px-2 py-2 text-center">
                      PETSA SA PAGLUMAT
                    </th>
                    <th className="border-b border-r border-stone-500 px-2 py-2 text-right">
                      KANTIDAD
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      DATA 15/15/30
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Ene 15/30
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Peb 15/28
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Pcb 15/28
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Abr 15/28
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Maj 15/28
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Jun 15/28
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Abr 15/28
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Oct 15/28
                    </th>
                    <th className="border-b border-r border-stone-500 px-1.5 py-2 text-right">
                      Dec 15/15/30
                    </th>
                    <th className="border-b border-stone-500 px-3 py-2 text-right font-black">
                      BALANCE
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-stone-400/50">
                  {rows.map((row, idx) => {
                    const isEven = idx % 2 === 0
                    const isHeaderRow = row.name.startsWith('Mga ')
                    return (
                      <tr
                        key={row.id}
                        className={`transition-colors ${
                          isHeaderRow
                            ? 'bg-amber-200 font-bold text-stone-900'
                            : isEven
                              ? 'bg-amber-50'
                              : 'bg-stone-100'
                        } hover:bg-amber-100`}
                      >
                        <td className="border-r border-stone-400/60 px-3 py-1.5 font-bold uppercase tracking-tight text-stone-900">
                          {row.name}
                        </td>
                        <td className="border-r border-stone-400/60 px-2 py-1.5 text-center font-mono text-[11px] text-stone-700">
                          {row.dateGrant}
                        </td>
                        <td className="border-r border-stone-400/60 px-2 py-1.5 text-right font-mono font-bold text-stone-900">
                          {row.principal ? row.principal.toLocaleString() : ''}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.data1530}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.ene1530}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.peb1528}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.pcb1528}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.abr1528}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.maj1528}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.jun1528}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.abr2_1528}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.oct1528}
                        </td>
                        <td className="border-r border-stone-400/60 px-1.5 py-1.5 text-right font-mono text-[11px]">
                          {row.dec1530}
                        </td>
                        <td className="px-3 py-1.5 text-right font-mono font-black text-stone-950">
                          {row.balance.toLocaleString('en-PH', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Signature Box */}
          <div className="mt-6 flex flex-wrap items-end justify-between gap-6 border-t-2 border-stone-400 pt-4">
            <div className="rounded-xl border-2 border-stone-500 bg-amber-100 px-6 py-4 shadow-sm">
              <div className="flex items-center gap-6">
                <div>
                  <p className="text-xs font-black uppercase text-stone-800">
                    PIRMA SA:
                  </p>
                  <p className="mt-0.5 text-sm font-black text-stone-900">
                    MGA KLIYENTE: 37,451
                  </p>
                </div>

                <div className="flex flex-col items-center">
                  <CursiveSignatureSVG className="h-14 w-44 -mb-3" />
                  <div className="w-48 border-t-2 border-stone-800 pt-1 text-center">
                    <p className="text-xs font-extrabold uppercase tracking-wider text-stone-900">
                      EDNA S. SANTOS
                    </p>
                    <p className="text-[10px] text-stone-600">
                      Authorized Cooperative Signatory
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-right text-xs font-semibold text-stone-600">
              <p>Form No. COOP-LEDGER-2026-PH</p>
              <p className="font-mono">Approved for PHP ₱50,000.00 Credit Limit</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

// ─── 2. TABLET DAILY COLLECTION SHEET VIEW ───────────────────────
function TabletCollectionSheetView({
  rows,
  activeTab,
  onSelectTab,
  totalPaid: _totalPaid,
  showToast: _showToast,
}: {
  rows: PaperLoanRow[]
  activeTab: string
  onSelectTab: (tab: any) => void
  totalPaid: number
  showToast: (msg: string) => void
}) {
  const tabs = [
    { id: 'TANANG', label: 'Tanang Matang' },
    { id: 'REGULAR', label: 'Regular' },
    { id: 'HEALTH_CENTER', label: 'Health Center' },
    { id: 'SENIOR', label: 'Senior' },
  ]

  return (
    <div className="w-full max-w-3xl overflow-hidden rounded-3xl border-8 border-stone-900 bg-stone-950 p-4 shadow-2xl">
      {/* Tablet Speaker/Camera Notch */}
      <div className="mb-3 flex items-center justify-between px-4 text-xs text-stone-400">
        <span className="font-mono text-[11px]">9:41 AM · Cebu City COOP</span>
        <div className="h-2.5 w-24 rounded-full bg-stone-800" />
        <span className="font-mono text-[11px]">100% 🔋 PHP Currency</span>
      </div>

      {/* Main Tablet Sheet */}
      <div className="rounded-2xl border-2 border-stone-500 bg-amber-50 p-5 shadow-lg">
        {/* Title Header */}
        <div className="mb-4 text-center">
          <h2 className="text-xl font-black uppercase tracking-wide text-stone-900">
            ADLAW-ADLAW NGA LISTAHAN SA KOLEKSYON
          </h2>
          <p className="text-xs font-bold uppercase tracking-wider text-stone-700">
            Daily Collection Roster — Cebuano / Bisaya Edition
          </p>
        </div>

        {/* Top Category Tabs */}
        <div className="mb-4 flex flex-wrap items-center justify-center gap-2">
          {tabs.map((t) => {
            const isActive = activeTab === t.id
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => onSelectTab(t.id as any)}
                className={`rounded-lg border px-4 py-1.5 text-xs font-black uppercase transition-all ${
                  isActive
                    ? 'border-stone-600 bg-amber-200 text-stone-950 shadow font-black ring-2 ring-stone-500'
                    : 'border-stone-400 bg-amber-100 text-stone-700 hover:bg-amber-200'
                }`}
              >
                {t.label}
              </button>
            )
          })}
        </div>

        {/* Tablet Table */}
        <div className="overflow-x-auto rounded-xl border-2 border-stone-500 bg-amber-50">
          <table className="w-full border-collapse text-left font-sans text-xs">
            <thead>
              <tr className="bg-amber-200 font-bold text-stone-900">
                <th className="border-b border-r border-stone-500 px-3 py-2 text-left">
                  MATANG SA EMPLEYADO
                </th>
                <th className="border-b border-r border-stone-500 px-3 py-2 text-left">
                  NGALAN SA MANGUTANG
                </th>
                <th className="border-b border-r border-stone-500 px-3 py-2 text-right">
                  DINAABOT NGA KANTIDAD
                </th>
                <th className="border-b border-r border-stone-500 px-3 py-2 text-right">
                  GIBAYAD
                </th>
                <th className="border-b border-stone-500 px-3 py-2 text-center">
                  STATUS
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-400/50">
              {rows.slice(0, 15).map((row, idx) => {
                const isEven = idx % 2 === 0
                const expected = row.principal > 5000 ? 3000 : row.principal > 3000 ? 2000 : 1000
                const paid = (expected * (idx % 2 === 0 ? 0.85 : 1.25)).toFixed(2)
                const categoryName =
                  row.category === 'REGULAR'
                    ? 'Regular'
                    : row.category === 'JOB_ORDER'
                      ? 'Job Order'
                      : row.category === 'HEALTH_CENTER'
                        ? 'Health Center'
                        : 'Senior'

                return (
                  <tr
                    key={row.id}
                    className={`transition-colors ${
                      isEven ? 'bg-amber-50' : 'bg-stone-100'
                    } hover:bg-amber-100`}
                  >
                    <td className="border-r border-stone-400/60 px-3 py-1.5 font-bold text-stone-800">
                      {categoryName}
                    </td>
                    <td className="border-r border-stone-400/60 px-3 py-1.5 font-bold uppercase tracking-tight text-stone-900">
                      {row.name}
                    </td>
                    <td className="border-r border-stone-400/60 px-3 py-1.5 text-right font-mono font-bold text-stone-800">
                      {expected.toLocaleString()}
                    </td>
                    <td className="border-r border-stone-400/60 px-3 py-1.5 text-right font-mono font-black text-stone-950">
                      {Number(paid).toLocaleString('en-PH', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="px-3 py-1.5 text-center">
                      <span
                        className={`inline-block rounded px-2 py-0.5 text-[10px] font-black uppercase ${
                          row.statusRemark === 'SULDO'
                            ? 'bg-amber-200 text-stone-900'
                            : 'bg-stone-300 text-stone-800'
                        }`}
                      >
                        {row.statusRemark || 'SULDO'}
                      </span>
                    </td>
                  </tr>
                )
              })}
            </tbody>
            {/* Total Footer Row */}
            <tfoot>
              <tr className="bg-amber-200 font-black text-stone-950">
                <td
                  colSpan={2}
                  className="border-t-2 border-r border-stone-500 px-3 py-2.5 text-right uppercase"
                >
                  TOTAL
                </td>
                <td className="border-t-2 border-r border-stone-500 px-3 py-2.5 text-right font-mono">
                  37,000
                </td>
                <td
                  colSpan={2}
                  className="border-t-2 border-stone-500 px-3 py-2.5 text-left font-mono text-base"
                >
                  ₱37,451.00
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Bottom Banner Card */}
        <div className="mt-4 rounded-xl border-2 border-stone-500 bg-amber-100 p-4 text-center shadow-md">
          <p className="text-xs font-black uppercase tracking-wider text-stone-800">
            PINAKADAKO NGA KANTIDAD SA HUWAMAN (Good For)
          </p>
          <p className="mt-1 font-mono text-2xl font-black text-stone-950">
            ₱50,000.00
          </p>
        </div>
      </div>
    </div>
  )
}

// ─── 3. MOBILE PHONE PROMISSORY VOUCHER VIEW ─────────────────────
function MobilePhoneVoucherView({
  amount,
  remaining,
  setAmount: _setAmount,
  showToast,
}: {
  amount: number
  remaining: number
  setAmount: (n: number) => void
  showToast: (msg: string) => void
}) {
  return (
    <div className="w-full max-w-[360px] overflow-hidden rounded-[40px] border-[10px] border-stone-900 bg-stone-950 p-3 shadow-2xl">
      {/* Phone Screen Notch */}
      <div className="mb-2 flex items-center justify-between px-3 text-[11px] font-semibold text-stone-400">
        <span>9:41</span>
        <div className="h-4 w-20 rounded-full bg-stone-900" />
        <span>4G · PHP</span>
      </div>

      {/* Main Manila Paper Voucher Screen */}
      <div className="flex flex-col justify-between rounded-3xl border-2 border-stone-500 bg-amber-50 p-4 shadow-lg min-h-[580px]">
        <div>
          {/* Header Title */}
          <div className="mb-4 border-b-2 border-stone-400 pb-3 text-center">
            <h3 className="text-base font-black uppercase tracking-wide text-stone-900">
              PASALIG NGA SULAT / VOUCHER
            </h3>
            <p className="text-[10px] font-bold uppercase text-stone-700">
              Promissory Voucher — Cooperative PHP
            </p>
          </div>

          {/* Good For Box */}
          <div className="mb-4 rounded-xl border-2 border-stone-500 bg-amber-100 p-3 text-center shadow-sm">
            <p className="text-xs font-extrabold uppercase text-stone-800">
              Susiha ang Huwaman (Good For)
            </p>
            <p className="text-xs font-semibold text-stone-700">Pinakadako:</p>
            <p className="mt-1 font-mono text-2xl font-black text-stone-950">
              ₱{amount.toLocaleString('en-PH', { minimumFractionDigits: 2 })}
            </p>
          </div>

          {/* Fields */}
          <div className="mb-4 space-y-3 text-xs">
            <div className="flex items-center justify-between border-b border-stone-400/50 pb-2">
              <span className="font-bold uppercase text-stone-800">Kantidad:</span>
              <span className="font-mono font-black text-stone-900 text-sm">
                ₱50,000.00
              </span>
            </div>
            <div className="flex items-center justify-between border-b border-stone-400/50 pb-2">
              <span className="font-bold uppercase text-stone-800">
                Nabilin nga
                <br />
                Puwedeng Huwaman:
              </span>
              <span className="font-mono font-black text-stone-950 text-sm">
                ₱{remaining.toLocaleString('en-PH', { minimumFractionDigits: 2 })}
              </span>
            </div>
          </div>

          {/* Script Signature Block */}
          <div className="my-6 flex flex-col items-center justify-center rounded-xl border border-stone-400/60 bg-amber-100 py-3">
            <p className="text-[11px] font-extrabold uppercase text-stone-800">
              Pirma:
            </p>
            <CursiveSignatureSVG className="h-14 w-40 -mb-2" />
            <p className="border-t border-stone-800 px-4 pt-0.5 text-xs font-black uppercase text-stone-900">
              EDNA S. SANTOS
            </p>
          </div>
        </div>

        {/* Action Buttons Grid */}
        <div className="space-y-2">
          {/* Top Row: APROBAHAN | I-SURE */}
          <div className="grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={() =>
                showToast('Aprobahan: Voucher Approved for ₱50,000.00 PHP!')
              }
              className="rounded-xl border-2 border-stone-500 bg-amber-200 py-2 text-center text-xs font-black uppercase text-stone-900 shadow-sm transition-all hover:bg-amber-300 active:scale-95"
            >
              APROBAHAN
            </button>
            <button
              type="button"
              onClick={() => showToast('I-SURE: Client identity & credit confirmed!')}
              className="rounded-xl border-2 border-stone-500 bg-amber-200 py-2 text-center text-xs font-black uppercase text-stone-900 shadow-sm transition-all hover:bg-amber-300 active:scale-95"
            >
              I-SURE
            </button>
          </div>

          {/* Second Row: HIMO | I-print Voucher */}
          <div className="grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={() => showToast('Himo: New Voucher Record Created in DB!')}
              className="rounded-xl border-2 border-stone-500 bg-amber-200 py-2 text-center text-xs font-black uppercase text-stone-900 shadow-sm transition-all hover:bg-amber-300 active:scale-95"
            >
              HIMO
            </button>
            <button
              type="button"
              onClick={() => {
                showToast('I-print Voucher: Preparing paper voucher for printing...')
                if (typeof window !== 'undefined') window.print()
              }}
              className="rounded-xl border-2 border-stone-500 bg-amber-200 py-2 text-center text-xs font-black uppercase text-stone-900 shadow-sm transition-all hover:bg-amber-300 active:scale-95"
            >
              I-print Voucher
            </button>
          </div>

          {/* Third Row: I-email Voucher */}
          <button
            type="button"
            onClick={() => showToast('I-email Voucher: Voucher PDF emailed to client!')}
            className="w-full rounded-xl border-2 border-stone-500 bg-amber-200 py-2 text-center text-xs font-black uppercase text-stone-900 shadow-sm transition-all hover:bg-amber-300 active:scale-95"
          >
            I-email Voucher
          </button>

          {/* Fourth Row: I-delete */}
          <button
            type="button"
            onClick={() => showToast('I-delete: Voucher deleted.')}
            className="w-full rounded-xl border-2 border-red-800/60 bg-red-100 py-2 text-center text-xs font-black uppercase text-red-950 shadow-sm transition-all hover:bg-red-200 active:scale-95"
          >
            I-delete
          </button>

          {/* Watermark */}
          <div className="pt-2 text-center">
            <p className="font-mono text-sm font-extrabold tracking-widest text-stone-700">
              ZapWeb.App
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
